import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Warning } from "../../../../icons/warning.js";
import { ls } from "../../../../strings.js";
export const GeneralError = () => {
    return (_jsxs("div", { className: "bg-bg-surface-critical flex rounded-lg p-2 gap-2", children: [_jsx(Warning, {}), _jsxs("div", { children: [_jsx("h2", { className: "text-fg-critical text-xs font-medium", children: ls.error.general.title }), _jsx("p", { className: "text-fg-critical text-xs", children: ls.error.general.body })] })] }));
};
//# sourceMappingURL=general-error.js.map